export default {
  RESPONSE_ANALYZER: 'response-analyzer'
}